export const AVAIL = ["weekday", "weekend", "evening"];
export const WORK = ["shopping", "carrying", "errands", "elderly", "homehelp"];

export const JOIN = {
  en: {
    h1: "CHELA ke saath kamaayein, apne time par.",
    intro: "Khali time mein {min}+/ghanta kamaayein. UPI se usi din payment. Tip 100% aapki.",
    cta: "Abhi apply karein",
    video_t: "CHELA mein kaam kaise hota hai",
    caption: "Khali time hai? CHELA ke saath kamaao. Apne time par kaam, {min}+ per hour, UPI se usi din payment, tip 100% tumhari. Abhi apply karo.",
    stock: "Representative footage, not real CHELA helpers.",
    calc_t: "Kitna kamaayenge?",
    hours_day: "Ghante per din", days_week: "Din per hafta",
    per_hour: "Per ghanta", per_week: "Per hafta", per_month: "Per mahina (4 hafte)",
    tip: "Tip alag se, 100% aapki.",
    steps_t: "Kaam kaise chalta hai",
    steps: ["Apply karein", "Call aur verification", "Chhota briefing", "Pehla job"],
    form_t: "Apply Now",
    required_note: "* Required",
    f: { name: "Name *", whatsapp: "WhatsApp Mobile Number *", areas: "Areas in Bhopal *", areas_ph: "e.g. MP Nagar, Kolar, New Market", work: "Which Work Would You Like to Do? *", availability: "When Are You Available?" },
    avail: { weekday: "Weekday", weekend: "Weekend", evening: "Evening" },
    work: { shopping: "Help with Shopping", carrying: "Lifting/Shifting Goods", errands: "Small Tasks", elderly: "Help at Home & Events", homehelp: "Home Help" },
    adult: "I am 18 years or older *",
    consent: "I agree to provide my information for verification *",
    no_id: "Aadhaar or photo is not required now. ID and selfie will be taken after the call.",
    submit: "Submit Application",
    success: "Thanks! We'll call or WhatsApp you soon.",
    need_checks: "Please tick both checkboxes",
    need_work: "Please choose at least one type of work",
    resp: [
      ["Aapka kaam", ["Customer ke saath shopping karna aur bags uthana", "Ek se zyada dukaan mein saath jaana", "Saman organise karna", "Chhote errands (pick up/drop, line mein khade hona)", "Ghar mein halka saman shift karna aur halka ghar ka kaam", "Buzurg family members ke saath market ya local travel mein madad (sirf non-medical)"]],
      ["Zaroor karein", ["Time par pahunchein (late ho toh pehle message karein)", "Saaf kapde aur tameez se baat", "Customer ka saman dhyan se sambhalein", "Kaam ke baad CHELA ko WhatsApp par update dein", "Kuch galat lage toh turant support ko batayein"]],
      ["Kabhi na karein", ["Customer ka cash/card/UPI PIN lena ya dekhna", "Customer ki ijaazat ke bina kisi kamre ya jagah mein jaana", "Customer ka number ya address kisi ko dena", "Customer se directly paisa maangna", "Medical care, painting, deep cleaning ya bhaari moving", "Nasha karke kaam par aana"]],
      ["Kamai", ["Fixed hourly rate", "Tip 100% aapki", "UPI se usi din ya agle din subah payment"]],
    ],
  },
  hi: {
    h1: "CHELA के साथ कमाएँ, अपने समय पर।",
    intro: "ख़ाली समय में {min}+/घंटा कमाएँ। UPI से उसी दिन पेमेंट। टिप 100% आपकी।",
    cta: "अभी अप्लाई करें",
    video_t: "CHELA में काम कैसे होता है",
    caption: "ख़ाली समय है? CHELA के साथ कमाओ। अपने समय पर काम, {min}+ प्रति घंटा, UPI से उसी दिन पेमेंट, टिप 100% तुम्हारी। अभी अप्लाई करो।",
    stock: "प्रतिनिधि फ़ुटेज, असली CHELA हेल्पर नहीं।",
    calc_t: "कितना कमाएँगे?",
    hours_day: "घंटे प्रति दिन", days_week: "दिन प्रति हफ़्ता",
    per_hour: "प्रति घंटा", per_week: "प्रति हफ़्ता", per_month: "प्रति महीना (4 हफ़्ते)",
    tip: "टिप अलग से, 100% आपकी।",
    steps_t: "काम कैसे चलता है",
    steps: ["अप्लाई करें", "कॉल और वेरिफ़िकेशन", "छोटी ब्रीफ़िंग", "पहला जॉब"],
    form_t: "अभी अप्लाई करें",
    required_note: "* ज़रूरी",
    f: { name: "नाम *", whatsapp: "WhatsApp मोबाइल नंबर *", areas: "भोपाल में एरिया *", areas_ph: "जैसे: एमपी नगर, कोलार, न्यू मार्केट", work: "आप कौन-सा काम करना चाहेंगे? *", availability: "आप कब उपलब्ध हैं?" },
    avail: { weekday: "वीकडे", weekend: "वीकेंड", evening: "शाम" },
    work: { shopping: "शॉपिंग में मदद", carrying: "सामान उठाना/शिफ़्ट करना", errands: "छोटे काम", elderly: "घर व इवेंट में मदद", homehelp: "घर का हल्का काम" },
    adult: "मेरी उम्र 18 साल या उससे ज़्यादा है *",
    consent: "मैं अपनी जानकारी वेरिफ़िकेशन के लिए देने को सहमत हूँ *",
    no_id: "आधार या फ़ोटो अभी ज़रूरी नहीं है। ID और सेल्फ़ी कॉल के बाद ली जाएगी।",
    submit: "एप्लिकेशन भेजें",
    success: "धन्यवाद! हम जल्द ही आपको कॉल या WhatsApp करेंगे।",
    need_checks: "कृपया दोनों बॉक्स पर टिक करें",
    need_work: "कम से कम एक काम चुनें",
    resp: [
      ["आपका काम", ["ग्राहक के साथ शॉपिंग करना और बैग उठाना", "एक से ज़्यादा दुकानों में साथ जाना", "सामान व्यवस्थित करना", "छोटे काम (पिक-अप/ड्रॉप, लाइन में खड़े होना)", "घर में हल्का सामान शिफ़्ट करना और घर का हल्का काम", "बुज़ुर्गों के साथ बाज़ार या लोकल सफ़र में मदद (सिर्फ़ ग़ैर-चिकित्सा)"]],
      ["ज़रूर करें", ["समय पर पहुँचें (देर हो तो पहले मैसेज करें)", "साफ़ कपड़े और तमीज़ से बात", "ग्राहक का सामान ध्यान से संभालें", "काम के बाद CHELA को WhatsApp पर अपडेट दें", "कुछ ग़लत लगे तो तुरंत सपोर्ट को बताएँ"]],
      ["कभी न करें", ["ग्राहक का कैश/कार्ड/UPI PIN लेना या देखना", "ग्राहक की इजाज़त के बिना किसी कमरे या जगह में जाना", "ग्राहक का नंबर या पता किसी को देना", "ग्राहक से सीधे पैसा माँगना", "मेडिकल केयर, पेंटिंग, डीप क्लीनिंग या भारी शिफ़्टिंग", "नशा करके काम पर आना"]],
      ["कमाई", ["तय घंटे का रेट", "टिप 100% आपकी", "UPI से उसी दिन या अगले दिन सुबह पेमेंट"]],
    ],
  },
};
